import React from 'react';
import ReactMailchimpSubscribe from 'react-mailchimp-subscribe';

class Subscribe extends ReactMailchimpSubscribe {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  render () {
    const { action, messages, styles } = this.props
    const { status } = this.state
    return (
    <div className="title-form-box subscribe">
      <h2>Rabbit の最新ニュースを購読する</h2>
      <form onSubmit={this.onSubmit} action={action} method="post">
        <input
          ref={node => (this.input = node)}
          type="email"
          defaultValue=""
          name="EMAIL"
          required={true}
          placeholder={messages.inputPlaceholder}
          onChange={this.handleChange}
        />
        <input
          type="submit"
          disabled={this.state.status === "sending" || this.state.status === "success"}
          value={messages.btnLabel}
        />
        {status === "sending" && <span className='status-message' style={styles.sending} dangerouslySetInnerHTML={{ __html: messages.sending }} />}
        {status === "success" && <span className='status-message' style={styles.success} dangerouslySetInnerHTML={{ __html: messages.success }} />}
        {status === "error" && <span  className='status-message' style={styles.error} dangerouslySetInnerHTML={{ __html: messages.error }} />}
      </form>
    </div>
    );
  }
  handleChange() {
    this.setState({
      status: null
    })
  }
}

Subscribe.defaultProps = {
  messages: {
    title: "Rabbit の最新ニュースを購読する",
    inputPlaceholder: "メールアドレスを入力してください",
    btnLabel: "購読する",
    sending: "購読中",
    success: "ご購読ありがとうございます！",
    error: "購読できませんでした"
  },
  styles: {
    sending: {
      color: "auto"
    },
    success: {
      color: "#0379C4"
    },
    error: {
      color: "red"
    }
  }
}

export default Subscribe



// WEBPACK FOOTER //
// ./src/components/form/subscribe.js